import './App.css';
import Routing from './Utils/Routing';

const App = () => {
  return (
    <div className="App">
      <Routing />
    </div>
  );
};

export default App;
